import { HashRouter } from "react-router";
import {
  Backdrop,
  CircularProgress,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { useAppDispatch } from "hooks/StoreHooks";
import Connection from "pages/Connection/Connection";
import Loading from "pages/Loading";
import { useEffect, useState } from "react";
import { routes } from "routes/routes";
import { setd_inv22g, setToken, setUser } from "store/Slices/appStateSlice";
import { D_INV22G, TOKEN, USER, USERNAME } from "constants/api/localStorage";
import { connectionApi } from "services/api/connectionApi";
import { Login } from "models/Resources/Login";
import { UserAuthorizations } from "models/UserAuthorization";

import "./constants/scss/fonts/DefaultFonts.scss";
import "./App.scss";

export const appTheme = createTheme({
  typography: {
    fontFamily: "\"Kern Standard\", sans-serif",
  },
});

function App() {
  const dispatch = useAppDispatch();

  const APPLICAT_TOKEN_PARAM = "applicatauthtoken";

  const [logInWithToken] =
    connectionApi.endpoints.logInWithToken.useLazyQuery();
  const [urlLoaded, setUrlLoaded] = useState(false);

  useEffect(() => {
    const getUrlInfos = async () => {
      const search = new URLSearchParams(window.location.href.split("?")[1]);
      if (search.get(APPLICAT_TOKEN_PARAM) !== null) {
        let token = search.get(APPLICAT_TOKEN_PARAM);
        const loginInfos = (await logInWithToken(token!).unwrap()) as Login;
        if (loginInfos.success) {
          token = loginInfos.token;
          setLoginInfos(loginInfos);
        } 
        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      } else if (search.get(TOKEN) !== null && search.get(USER) !== null) {
        const token = search.get(TOKEN);
        localStorage.setItem(USER, `${search.get(USER)}`);
        localStorage.setItem(TOKEN, `${search.get(TOKEN)}`);
        dispatch(setToken(`Bearer ${token}`));
        dispatch(setUser(search.get(USER)!));
        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      }
      setUrlLoaded(true);
    };
    getUrlInfos();
  }, [dispatch]);

  function setLoginInfos(loginInfos: Login) {
    setLoggedUser(loginInfos.user);
    setLoggedName(loginInfos.name);
    setLoggedToken(loginInfos.token);
    setWantedAuthorizations(loginInfos.authorizations);
  }

  function setLoggedUser(user: string) {
    localStorage.setItem(USER, user);
    dispatch(setUser(user));
  }

  function setLoggedName(name: string) {
    localStorage.setItem(USERNAME, name);
  }

  function setLoggedToken(token: string) {
    localStorage.setItem(TOKEN, token);
    dispatch(setToken(`${token}`));
  }

  function setWantedAuthorizations(authorizations: UserAuthorizations[]) {
    const d_inv22g = authorizations.find(
      (a: UserAuthorizations) => a.functName === D_INV22G
    );
    if (d_inv22g) {
      dispatch(setd_inv22g(d_inv22g));
    } else {
      localStorage.clear();
    }
  }

  return urlLoaded ? (
    <Connection>
      <Loading>
        <ThemeProvider theme={appTheme}>
          <HashRouter>{routes}</HashRouter>
        </ThemeProvider>
      </Loading>
    </Connection>
  ) : (
    <Backdrop sx={{ color: "#fff", zIndex: 2147483647 }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default App;
